const menuItems = [
    { 
        type: 'item', 
        section: 'overview', 
        text: 'data', 
        key:'i-overview' 
    },
    { 
        type: 'item', 
        section: 'groups', 
        text: 'groups', 
        key:'i-groups' 
    },
    { 
        type: 'item', 
        section: 'doctors', 
        text: 'doctors', 
        key:'i-doctors' 
    },
    // { 
    //     type: 'item', 
    //     section: 'patients', 
    //     text: 'patients', 
    //     key: 'i-patients'
    // }, 
    { 
        type: 'item', 
        section: 'supportTickets', 
        text: 'tickets', 
        key:'i-tickets' 
    },
    { 
        type: 'item', 
        section: 'faxLogs',
        text: 'faxLogs', 
        key:'i-faxLogs' 
    },
    { 
        type: 'item', 
        section: 'referrals', 
        text: 'referrals', 
        key:'i-referrals' 
    },
    { 
        type: 'item', 
        section: 'team', 
        text: 'team', 
        key:'i-team' 
    },
    { 
        type: 'item', 
        section: 'hackers', 
        text: 'hackers', 
        key:'i-hackers' 
    },
];

export default menuItems;